import React from 'react';
import readableFileSize from 'filesize';
import DetailItem from './DetailItem';
import { deviationHasFileSizeMetadata } from './helpers';
export var OriginalSize = function (_a) {
    var deviation = _a.deviation;
    if (!deviationHasFileSizeMetadata(deviation)) {
        return null;
    }
    var _b = deviation.extended.originalFile, filesize = _b.filesize, width = _b.width, height = _b.height;
    return (React.createElement(DetailItem, { name: "itemsize", value: "".concat(width, "x").concat(height, "px ").concat(readableFileSize(filesize)) }));
};
OriginalSize.displayName = 'OriginalSize';
export default OriginalSize;
//# sourceMappingURL=OriginalSize.js.map